export const ctaSection = {
  title: "¿Quieres conocernos?",
  subtitle: "Programa una visita y descubre cómo podemos acompañar el desarrollo de tu hijo",
  bookVisit: "Reservar visita"
};
